import { defineEvent } from '../types/event';
export var COUPON_MODAL_SMS_FAIL = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        },
        {
            name: 'Heap',
            alias: 'coupon-modal_sms-failure'
        }
    ]
});
